const DEFERRED_TOAST_KEY = 'lens_deferred_toast';

export function stashDeferredToast(message, variant = 'warn') {
    if (!message || typeof sessionStorage === 'undefined') return;
    try {
        sessionStorage.setItem(
            DEFERRED_TOAST_KEY,
            JSON.stringify({
                message: String(message),
                variant: variant === 'error' || variant === 'info' ? variant : 'warn',
            }),
        );
    } catch {
        // ignore quota / private mode
    }
}

export function consumeDeferredToast() {
    if (typeof sessionStorage === 'undefined') return null;
    try {
        const raw = sessionStorage.getItem(DEFERRED_TOAST_KEY);
        sessionStorage.removeItem(DEFERRED_TOAST_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.message) return null;
        return parsed;
    } catch {
        sessionStorage.removeItem(DEFERRED_TOAST_KEY);
        return null;
    }
}
